import { BodySmall } from '@src/fonts/typography/Typography';
import styled from 'styled-components';

export const Container = styled.article`
  width: 100%;
  pointer-events: all;
  overflow: hidden;
  max-width: 402px;
  margin: 0 auto;
  border-radius: 1.5rem;
  padding: 1.5rem;
  background-color: white;

  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const Description = styled.div`
  width: 100%;

  p {
    ${BodySmall};
    color: #616161;
    font-size: 14px;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 0.875rem;
  margin-top: 1rem;

  button {
    width: fit-content;

    svg {
      margin-right: 0.25rem;
      margin-left: 0rem;
    }
  }
`;
